










import { Component, Vue, Mixins } from 'vue-property-decorator'
import ModalBase from '@/components/molecules/ModalBase.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ModalBaseMethod from '@/components/molecules/ModalBaseMethod.vue'
import { COURSE_TEXTS } from '@/views/teacher/v3/StudentConfirm.vue'
import TableBase from '@/components/atoms/TableBase1110.vue'
import dayjs from 'dayjs'

export type CourseResponse = {
  courseType: 'standard' | 'aligned'
  courseData: {
    subjectName: string
    gradeName: string
    publisherCode: string
    startDate?: string
    endDate?: string
    subjectId: number
    gradeId?: number
  }[]
}

@Component({
  components: {
    ModalBase,
    ButtonBase,
    TableBase,
  },
})
export default class ModalStudentCourses extends Mixins(ModalBaseMethod) {
  private studentCourseFields: object[] = [
    { key: 'gradeName', label: '学年' },
    { key: 'subjectName', label: '教科' },
    { key: 'course', label: 'コース' },
    { key: 'publisherName', label: '教科書会社' },
    { key: 'date', label: '利用期間' },
  ]

  private loading = false

  private userId: number | null = null

  private studentCourseItems = []

  private editStudent() {
    this.$router.push(`/teacher/setting/v3/student/create/info?id=${this.userId}`)
  }

  public showModal(studentId: number, id: number, courseType: 'standard' | 'aligned') {
    this.loading = true
    this.userId = id

    Vue.prototype.$http.httpWithToken
      .get(`/v3/students/${studentId}/courses`)
      .then((res: any) => {
        const course = res.data.find((c: CourseResponse) => c.courseType === courseType)
        this.studentCourseItems = course.courseData.map((course: any) => {
          const startDate = dayjs(course.startDate)
          const endDate = dayjs(course.endDate)
          const month = endDate.diff(startDate, 'month') + 1
          return {
            gradeName: course.gradeName,
            subjectName: course.subjectName,
            course: COURSE_TEXTS[courseType],
            publisherName: courseType === 'aligned' ? course.publisherName : 'ー',
            date: course.startDate
              ? `${startDate.format('YYYY/MM/DD')} ～ ${endDate.format('YYYY/MM/DD')}${'　'}${month}ヶ月`
              : 'ー',
          }
        })
      })
      .finally(() => {
        this.loading = false
      })
    this.show()
  }
}
